//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import _ from 'lodash';
import { mapActions, mapGetters } from 'vuex';

export default {
  props: {
    itemText: { type: Function, default: (e) => e.userName },
    itemValue: { type: Function, default: (e) => e.id },
    clearable: { type: Boolean, default: true },
    hideDetails: { type: Boolean, default: false },
    multiple: { type: Boolean, default: true },
    className: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    error: { type: Boolean, default: false },
    value: { type: [Array, Object, Number, Boolean], default: () => [] },
    label: { type: String, default: '' },
    width: { type: String, default: '' },
    returnObject: { type: Boolean, default: false },
    exactUsersRole: { type: [String, Array, Number], default: () => [] },
  },

  data() {
    return {
      searchString: '',
      loading: false,
      items: [],
    };
  },

  computed: {
    ...mapGetters('users', ['setPending']),
    style() {
      return {
        width: this.width,
      };
    },

    getNoDataText() {
      // Пользователь еще ни разу не вводил ничего в строку поиска и загрузка выключена
      if (!this.searchString && !this.loading) {
        return this.$t('Enter username to search');
      }

      // Загрузка включена, состояние массива не важно
      if (this.loading) {
        return this.$t('Looking for such a user');
      }

      // Загрузка выключена, а массив пуст
      if (!this.loading && this.items.length === 0) {
        return this.$t('We did not find such user');
      }

      return '';
    },

    searchResult() {
      const { items } = this;
      return items;
    },
  },

  watch: {
    searchString(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.updateSearchString();
      }
    },
  },

  methods: {
    ...mapActions('users', ['getUsersByExactParams', 'getUsers']),

    input(value) {
      this.$emit('input', value);
    },

    updateSearchString() {
      const { searchString } = this;
      if (!searchString) return;
      this.setPending(true);
      this.loading = true;
      this.loadUsers();
    },

    loadUsers: _.debounce(async function load() {
      const { searchString } = this;
      const rolesType = typeof this.$props.exactUsersRole;
      let payload = this.$props.exactUsersRole ? {} : searchString;

      if (this.$props.exactUsersRole) {
        switch (rolesType) {
          case 'object':
            payload.roleList = this.$props.exactUsersRole;
            break;
          case 'number':
          case 'string':
            payload.roleList = [this.$props.exactUsersRole];
            break;
          default:
            break;
        }
        payload = { ...payload, searchString };
      }

      const { items } = await this.getUsersByExactParams(payload);
      this.items = [...this.items, ...items];
      this.loading = false;
      this.setPending(false);
    }, 500),
  },
};
